module.exports = __webpack_public_path__ + "img/RECUADRO_Development.ca0dceae.png";